var pym = require("./lib/pym");
var pymChild = null;
var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");

// check if this user has set "prefers reduced motion" in their browser
// https://since1979.dev/respecting-prefers-reduced-motion-with-javascript-and-react/
const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

var itemVisible = function(e) {
  e.forEach((item, i) => {
    if (item.isIntersecting) {
      // console.log("visible", item);
      item.target.classList.add("active");
      item.target.classList.remove("inactive");
    } else {
      // console.log("not visible", item);
      // item.target.classList.remove("active");
      // item.target.classList.add("inactive");
    }
  });
  pymChild.sendHeight();
}

// only want the funky left margin to happen on larger screens
var setItemMargins = function() {
  var items = document.querySelectorAll(".pillar .item");
  items.forEach((item, i) => {
    if (isMobile.matches) {
      item.style.marginLeft = 0;
    } else {
      item.style.marginLeft = item.dataset.marginLeft;
    }
  });
}

var onResize = function() {
  setItemMargins();
  pymChild.sendHeight();
}

// initial setup
pym.then(child => {
  pymChild = child;
  setItemMargins();

  // show items when they're visible onscreen
  // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
  if (!reducedMotion.matches) {
    let observer = new IntersectionObserver(itemVisible, { threshold: 0.5 });
    var items = document.querySelectorAll(".pillar .item");
    items.forEach((item, i) => {
      item.classList.add("inactive");
      observer.observe(item);
    });
  } else {
    item.classList.add("active");
  }

  pymChild.sendHeight();
  window.addEventListener("resize", onResize);
});
